import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-tuichu",
  "use": "icon-icon-tuichu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-tuichu\"><path d=\"M153.9584 102.4a43.008 43.008 0 0 0-43.1616 43.1616v732.8768c0 23.7568 19.456 43.1616 43.1616 43.1616h482.7136a43.008 43.008 0 0 0 43.1616-43.1616 43.264 43.264 0 0 0-43.1616-43.1104H197.5296V188.672h439.1424a43.008 43.008 0 0 0 43.1616-43.1104 43.264 43.264 0 0 0-43.1616-43.1616H153.9584z m552.4992 204.8512a43.1104 43.1104 0 0 0-30.5152 13.0048 43.1104 43.1104 0 0 0 0.4096 61.2352l88.576 87.1424H432.2304a43.008 43.008 0 0 0-43.1104 43.1616c0 23.7056 18.944 43.1104 43.1104 43.1104h332.288l-88.064 87.552a43.1104 43.1104 0 0 0 0 61.2864c8.192 8.6528 19.3536 12.9536 30.5664 12.9536 11.264 0 22.016-4.3008 30.6688-12.4928l162.6112-162.2016c8.192-8.192 12.9536-19.456 12.9536-30.6688a43.1616 43.1616 0 0 0-12.9536-30.6176l-163.072-160.9216a43.1104 43.1104 0 0 0-30.72-12.544z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-tuichu.svg
// module id = sHH9
// module chunks = 3